import { render } from "./secondary-header.vue?vue&type=template&id=e7bbdb90"
import script from "./secondary-header.vue?vue&type=script&lang=js"
export * from "./secondary-header.vue?vue&type=script&lang=js"

import "./secondary-header.vue?vue&type=style&index=0&id=e7bbdb90&lang=scss"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__